<allianz-button
  icon="pen"
  i18n-label="@@edit-button.label"
  label="Edit"
  testId="edit-button"
  [nxButtonType]="nxButtonType() || 'secondary small'"
  [disabled]="disabled()"
  (click)="action()()"
>
</allianz-button>
